// Vue
import {
  Route,
  NavigationGuardNext as Next,
} from 'vue-router'

// Services
import { getCookie, Auth } from '../lib/cookie'

export class AdminGuard {

  static isSigned() {
    return getCookie(Auth.AccessToken)
  }

  /**
   * Admin route guard handler
   * @param {Route} from
   * @param {Route} to
   * @param {Next} next
   * @returns {Boolean}
   */
  static watch(_,__, next) {
    AdminGuard.isSigned()
      ? next()
      : next('/admins/logins')
  }
}



// WEBPACK FOOTER //
// ./src/router/admin-guard.js